import * as types from '../../../actions/types';
import createReducer from '../../../../utils/createReducer';

const check_in = new Date();
check_in.setDate(check_in.getDate() + 1);

const check_out = new Date();
check_out.setDate(check_out.getDate() + 2);

const initialHotelsState = {
	search: {
		check_in,
		check_out,
		adults: 1,
		children: 0,
		passengers: 1,
		children_ages: [],
		location: {},
		label: '',
		countryName: '',
		errors: {}
	},
	searcher: {
		show: false,
		locations: []
	}
};

export const hotelsSearchReducer = createReducer(initialHotelsState, {
	[types.SHOW_SEARCHER_HOTEL](state) {
		const newSearcher = Object.assign({}, state.searcher, { show: !state.searcher.show });
		return Object.assign({}, state, { searcher: newSearcher });
	},
	[types.SET_HISTORIC_HOTEL](state, action) {
		return Object.assign({}, state, { queries: action.queries });
	},
	[types.SHOW_HISTORIC_HOTEL](state, action) {
		return Object.assign({}, state, { show_historic: action.show });
	},
	// Set new locations search from databases
	[types.SET_LOCATIONS_HOTEL](state, action) {
		const newState = { ...state, searcher: { ...state.searcher, locations: action.locations } }
		return newState
	},
	// Update search with selected places
	[types.UPDATE_SEARCH_HOTEL](state, action) {
		const newState = { ...state, search: { ...state.search, ...action.search } }

		return newState
	},
	[types.UPDATE_HOTEL_SEARCH_PASSENGERS](state, action) {
		// If we decrement and there are no passengers, return previous state
		if (state.search.passengers + action.numPassengers <= 0) return state;

		// If we decrement and there are less than 0 passengers from current type, return previous state
		if (state.search[action.passengerType] + action.numPassengers < 0) return state;

		// If we increment and there are more than 9 passengers in total, return previous state
		if (state.search.passengers + action.numPassengers > 9) return state;

		// Copy of current state children_ages
		let children_ages = state.search.children_ages.slice();

		if (action.passengerType === 'children')
			children_ages = [...Array(state.search.children + action.numPassengers)].map((x, i) => {
				if (children_ages[i] === undefined) return 1;
				return children_ages[i];
			});

		const passengers = Object.assign({},
			{ passengers: (state.search.passengers + action.numPassengers) },
			{ [action.passengerType]: state.search[action.passengerType] + action.numPassengers },
			{ children_ages }
		);

		// Merge last state search with our new state properties
		const newSearchPassengers = Object.assign({}, state.search, passengers);

		// Merge the search object inside all the state
		return Object.assign({}, state, { search: newSearchPassengers });
	},
	[types.UPDATE_CHILDREN_AGE](state, action) {
		const { childIndex, age } = action;

		// Copy of current state children_ages
		const newAges = state.search.children_ages.slice();

		// We change the value
		newAges[childIndex] = age;

		// Merge current search state with new ages
		const newSearch = Object.assign({}, state.search, { children_ages: newAges });

		// Merge the search object inside all the state
		return Object.assign({}, state, { search: newSearch });
	},
	[types.CLEAN_SEARCH](state, action) {
		return Object.assign({}, state, initialHotelsState);
	}
});
